module.exports = __webpack_public_path__ + "img/34800.3f96fc26.jpg";